var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.5171C28.5 6.78515 22.2319 0.51709 14.5 0.51709C6.76806 0.51709 0.5 6.78515 0.5 14.5171C0.5 21.5048 5.61963 27.2968 12.3125 28.347V18.564H8.75781V14.5171H12.3125V11.4327C12.3125 7.92396 14.4027 5.98584 17.6006 5.98584C19.1322 5.98584 20.7344 6.25928 20.7344 6.25928V9.70459H18.9691C17.2299 9.70459 16.6875 10.7838 16.6875 11.891V14.5171H20.5703L19.9496 18.564H16.6875V28.347C23.3804 27.2968 28.5 21.5049 28.5 14.5171Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9496 18.564L20.5703 14.5171H16.6875V11.891C16.6875 10.7837 17.2299 9.70459 18.9691 9.70459H20.7344V6.25928C20.7344 6.25928 19.1322 5.98584 17.6005 5.98584C14.4027 5.98584 12.3125 7.92396 12.3125 11.4327V14.5171H8.75781V18.564H12.3125V28.347C13.0361 28.4604 13.7675 28.5173 14.5 28.5171C15.2325 28.5173 15.9639 28.4604 16.6875 28.347V18.564H19.9496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFacebook);
export default __webpack_public_path__ + "static/media/logos_facebook.56785ad50cfd063951d4dbf3db0da67c.svg";
export { ForwardRef as ReactComponent };